import PropTypes from 'prop-types';

export default PropTypes.oneOf(['CB', 'YB', 'B', 'VM']);
